import { useQuery } from "@tanstack/react-query";

import useGetAccessToken from "components/Login/useGetAccessToken";
import { listShareLinks } from "../methods/shareFile";
import { SHARES_QUERY_KEY } from "./shareKeys";

type UseShareLinksOptions = {
  fileId: string;
};

/**
 * List a file's share links (file-api ADR 036). The share modal mounts only
 * while open, so this fetches on open and re-fetches on each reopen (the modal
 * unmounts on close), reflecting a link expired or revoked in another tab.
 * Share status is mutable, so staleTime is 0 — no caching of a possibly-dead
 * link across opens.
 */
export default function useShareLinks({ fileId }: UseShareLinksOptions) {
  const getAccessToken = useGetAccessToken();

  return useQuery({
    queryKey: SHARES_QUERY_KEY(fileId),
    queryFn: () => listShareLinks(fileId, getAccessToken),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 0,
  });
}
